import { AxiosError } from 'axios'
import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface ListProfessionalsAutoSuggestProps {
  fullNameContains?: string
  perPage?: number
  page?: number
  startDate?: string
  endDate?: string
  profileRole?: string
}

interface ProfessionalData {
  id: number
  fullName: string
}

interface ProfessionalResponse {
  id: number
  full_name: string
}

interface Response {
  data: {
    professionals: ProfessionalResponse[]
    pagination: {
      total: number
      page: number
      pages: number
    }
  }
}

interface ProfessionalsData {
  professionals: ProfessionalData[]
  pagination: {
    total: number
    page: number
    pages: number
  }
}

const listProfessionalsAutoSuggest = ({
  page,
  fullNameContains,
  perPage,
  startDate,
  endDate,
  profileRole
}: ListProfessionalsAutoSuggestProps): Promise<ProfessionalsData> => {

  const endpoint = apiEndpoints.PROFESSIONALS_AUTOSUGGEST

  const params = {
    ...(fullNameContains && { query: fullNameContains }),
    ...(perPage && { per_page: perPage }),
    ...(page && { page }),
    ...(startDate && { start_date: startDate }),
    ...(endDate && { end_date: endDate }),
    ...(profileRole && { profile_role: profileRole }),
  }

  return new Promise<ProfessionalsData> ((resolve, reject) => {
    axios.get(endpoint, { params })
      .then((response: Response) => {
        const professionals = response.data.professionals.map(professional => {
          return {
            fullName: professional.full_name,
            id: professional.id,
          } as ProfessionalData
        })  

        const professionalsData = {
          pagination: response.data.pagination,
          professionals: professionals
        } as ProfessionalsData
        
        resolve(professionalsData)
      })
      .catch(((err: AxiosError) => reject(err.response?.status)))
  })
}

export { listProfessionalsAutoSuggest }